import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
} from 'app/utils/redux/helpers';
import history from 'app/routes/history';
import { stripeSessionSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { sagaActions } from 'app/ducks/stripeSessions/actions';
import { StripeSessionsActionTypes as types } from 'app/ducks/stripeSessions/types';

function* createStripeSessionSaga(action): any {
  yield put(sagaActions.createStripeSessionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).stripeSessions.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, stripeSessionSchema);
    const currentSession = normalizedResponse.entities.stripeSessions[normalizedResponse.result];
    // history.push(currentSession.stripeRedirectUrl);
    window.location.href = currentSession.stripeRedirectUrl;

    yield put(sagaActions.createStripeSessionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createStripeSessionFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateStripeSessionSaga(action): any {
  yield put(sagaActions.updateStripeSessionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).stripeSessions.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, stripeSessionSchema);

    yield put(sagaActions.updateStripeSessionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateStripeSessionFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getStripeSessionSaga(action): any {
  yield put(sagaActions.getStripeSessionPending());
  const [error, response] = yield (yield TeammoApi(yield select())).stripeSessions.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, stripeSessionSchema);
    // console.log('111111111');
    // console.log(response, normalizedResponse);
    // console.log('222222222');

    yield put(sagaActions.getStripeSessionSuccess(normalizedResponse));
    // if (!_.isEmpty(normalizedResponse.paymentEvent.id)) {
    //   const peNormalizedResponse = normalize(response, paymentEventSchema);
    //   yield put(
    //     yield paymentEventSagaActions.getPaymentEventSuccess(
    //       peNormalizedResponse,
    //     ),
    //   );
    // }
    return normalizedResponse.entities.stripeSessions[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getStripeSessionFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

// function* getAllStripeSessionsSaga(action): any {
//   yield put(
//     sagaActions.getAllStripeSessionsPending(
//       action.payload.compile ? action.payload.pagination : {},
//     ),
//   );
//   yield put(loadingStart());

//   const paginationObject = action.payload.compile
//     ? compilePaginationObject(
//       yield select((state) => state.stripeSessions.pagination),
//     )
//     : action.payload.pagination;

//   const [error, response] = yield TeammoApi(
//     yield select(),
//   ).stripeSessions.list(paginationObject);

//   if (response) {
//     const normalizedResponse = normalize(response, stripeSessionListSchema);

//     yield put(
//       sagaActions.getAllStripeSessionsSuccess(
//         normalizedResponse,
//         response.meta,
//       ),
//     );
//     yield put(loadingFinish());
//   } else {
//     yield put(
//       error,
//       sagaActions.getAllStripeSessionsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
//     );
//   }
// }

/* ********************************* SAGA WATCHERS ********************************* */

function* createStripeSessionSagaWatcher(): any {
  yield takeEvery(types.CREATE_STRIPE_SESSION_REQUESTED, createStripeSessionSaga);
}

function* updateStripeSessionSagaWatcher(): any {
  yield takeLatest(types.UPDATE_STRIPE_SESSION_REQUESTED, updateStripeSessionSaga);
}

function* getStripeSessionSagaWatcher(): any {
  yield takeEvery(types.GET_STRIPE_SESSION_REQUESTED, getStripeSessionSaga);
}

// function* getAllStripeSessionsSagaWatcher(): any {
//   yield takeLatest(
//     types.GET_ALL_STRIPE_SESSIONS_REQUESTED,
//     getAllStripeSessionsSaga,
//   );
// }

export default function* root(): any {
  yield all([
    createStripeSessionSagaWatcher(),
    updateStripeSessionSagaWatcher(),
    getStripeSessionSagaWatcher(),
    // getAllStripeSessionsSagaWatcher(),
  ]);
}
